var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.items,"label":"Combobox","multiple":"","clearable":""},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})}
var staticRenderFns = []

export { render, staticRenderFns }